(function () {
  function handleSizeFinder(event) {
    var root = event.target.closest && event.target.closest('#arvento-size-finder');
    if (!root) return;
    if (event.type === 'click' && !event.target.closest('button')) return;

    event.preventDefault();
    event.stopPropagation();

    var height = root.querySelector('#asf-height');
    var weight = root.querySelector('#asf-weight');
    var usualSize = root.querySelector('#asf-usual-size');
    var preference = root.querySelector('#asf-preference');

    if (!height.value || !weight.value || !usualSize.value || !preference.value) return;

    var kg = Number(weight.value);
    var isSpanish=(document.documentElement.lang||'').toLowerCase().indexOf('es')===0;var isItalian=(document.documentElement.lang||'').toLowerCase().indexOf('it')===0;var isJapanese = (document.documentElement.lang||'').toLowerCase().indexOf('ja')===0;
    var isChinese = document.documentElement.lang.indexOf('zh') === 0;
    var result = root.querySelector('.wm-size-result');
    if (result) result.remove();

    result = document.createElement('section');
    result.className = 'asf-result wm-size-result';
    result.style.cssText = 'margin-top:28px;padding:28px;background:#f4f4f1;border:1px solid #e2e2dd;';

    if (kg > 90) {
      result.innerHTML = '<div style="color:#c62828;font-weight:600;font-size:18px;line-height:1.6">' +
        (isSpanish?"Tus medidas están fuera del rango para el que podemos recomendar una talla actualmente. Consulta la tabla de tallas antes de comprar.":isItalian?"Le tue misure non rientrano nell’intervallo per cui possiamo attualmente consigliare una taglia. Consulta la tabella delle taglie prima di ordinare.":isJapanese?'入力された身長・体重は、現在おすすめできるサイズの範囲外です。ご注文前にサイズ表をご確認ください。':(isChinese
          ? '您的身形數據超出目前建議尺寸範圍。下單前請參考尺寸表。'
          : 'Your measurements are outside our current recommended size range. Please refer to the size chart before ordering.')) +
        '</div>';
      root.appendChild(result);
      return;
    }

    var sizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL / 2XL'];
    var baseIndex = kg <= 55 ? 0 : kg <= 63 ? 1 : kg <= 72 ? 2 : kg <= 82 ? 3 : 4;
    var fit = preference.value;
    var sizeIndex = Math.min(5, baseIndex + (fit === 'comfort' ? 2 : fit === 'regular' ? 1 : 0));

    result.innerHTML = '<b>' + (isSpanish?"TALLA RECOMENDADA":isItalian?"TAGLIA CONSIGLIATA":isJapanese?'おすすめサイズ':(isChinese ? '建議尺寸' : 'RECOMMENDED SIZE')) + '</b>' +
      '<div style="font-size:56px;font-weight:700;margin:18px 0">' + sizes[sizeIndex] + '</div>' +
      '<div>' + (isSpanish?"Recomendación basada en la altura, el peso y el ajuste que prefieres.":isItalian?"Consiglio basato su altezza, peso e vestibilità preferita.":isJapanese?'身長・体重・好みのフィットに基づくおすすめです。':(isChinese ? '依照身高、體重與版型偏好所建議。' : 'Recommended from height, weight and fit preference.')) + '</div>';
    root.appendChild(result);
  }

  document.addEventListener('click', handleSizeFinder);
  document.addEventListener('submit', handleSizeFinder);
})();